module.exports = __webpack_public_path__ + "img/pass.3dc67093.png";